import {css} from "lit-element/lit-element.js";
export default css`
.controls {
  margin: 1em 0;
  display: flex;
}
.controls select {
  margin-left: 0.5em;
}
.controls progress {
  margin: 0 1em;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL3RtcC9iaWdfdmlzaW9uL2JpZ192aXNpb24vdG9vbHMvbGl0X2RlbW8vc3JjL2NvbXBvbmVudHMiLCJzb3VyY2VzIjpbIm1vZGVsLWNvbnRyb2xzLnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7RUFDRTtFQUNBOztBQUVBO0VBQ0U7O0FBR0Y7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi5jb250cm9scyB7XG4gIG1hcmdpbjogMWVtIDA7XG4gIGRpc3BsYXk6IGZsZXg7XG5cbiAgc2VsZWN0IHtcbiAgICBtYXJnaW4tbGVmdDogMC41ZW07XG4gIH1cblxuICBwcm9ncmVzcyB7XG4gICAgbWFyZ2luOiAwIDFlbTtcbiAgfVxufVxuIl19 */`;
